const getKey = id => `filtering-${id}`;

export const encode = data => {
  return JSON.stringify(data);
};

export const decode = data => {
  if (!data) return undefined;
  return JSON.parse(data);
};

export const setFiltering = (tableId, columnFilters) => {
  return window.localStorage.setItem(getKey(tableId), encode(columnFilters));
};

export const getFiltering = tableId => {
  return decode(window.localStorage.getItem(getKey(tableId))) || [];
};
